import {Routes} from '@angular/router';
import {authGuard} from './Core/Guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding',
    pathMatch: 'full',
  },
  {
    path: 'onboarding',
    loadComponent: () => import('./Pages/Auth/onboarding/onboarding.page').then((m) => m.OnboardingPage),
  },
  {
    path: 'home',
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadChildren: () => import('./Pages/Core/tabs/tabs.routes').then((m) => m.TABS_ROUTES),
      },
      {
        path: 'orders',
        children: [
          {
            path: 'order/:id',
            loadComponent: () => import('./Pages/Orders/order-detail/order-detail.page').then((m) => m.OrderDetailPage),
          },
        ],
      },
      {
        path: 'receipts',
        children: [
          {
            path: 'receipt/:id',
            loadComponent: () => import('./Pages/Receipts/receipt-detail/receipt-detail.page').then((m) => m.ReceiptDetailPage),
          },
        ],
      },
      {
        path: 'delivery-notes',
        children: [
          {
            path: 'delivery-note/:id',
            loadComponent: () => import('./Pages/Delivery-notes/delivery-note-detail/delivery-note-detail.page').then((m) => m.DeliveryNoteDetailPage),
          },
        ],
      },
      {
        path: 'options-menu',
        loadComponent: () => import('./Pages/Menu/options-menu/options-menu.page').then((m) => m.OptionsMenuPage),
      },
      {
        path: 'add-order',
        loadComponent: () => import('./Pages/Orders/add-order/add-order.page').then((m) => m.AddOrderPage),
      },
      {
        path: 'send-invitation',
        loadComponent: () => import('./Pages/Clients/send-invitation/send-invitation.page').then((m) => m.SendInvitationPage),
      },
      {
        path: 'add-client',
        loadComponent: () => import('./Pages/Clients/add-client/add-client.page').then((m) => m.AddClientPage),
      },
      {
        path: 'add-user',
        loadComponent: () => import('./Pages/Users/add-user/add-user.page').then((m) => m.AddUserPage),
      },
      {
        path: 'add-product',
        loadComponent: () => import('./Pages/Products/add-product/add-product.page').then((m) => m.AddProductPage),
      },
      {
        path: 'edit-password-user',
        loadComponent: () => import('./Pages/Configuration/edit-password-user/edit-password-user.page'   ).then((m) => m.EditPasswordUserPage),
      },
      {
        path: 'edit-profile-user',
        loadComponent: () => import('./Pages/Configuration/edit-profile-user/edit-profile-user.page'   ).then((m) => m.EditProfileUserPage),
      },
      {
        path: 'add-receipt',
        loadComponent: () => import('./Pages/Receipts/add-receipt/add-receipt.page').then((m) => m.AddReceiptPage),
      },
      {
        path: 'add-delivery-note',
        loadComponent: () => import('./Pages/Delivery-notes/add-delivery-note/add-delivery-note.page'   ).then((m) => m.AddDeliveryNotePage),
      },
      {
        path: 'add-line-order',
        loadComponent: () => import('./Pages/Orders/add-line-order/add-line-order.page').then((m) => m.AddLineOrderPage),
      },
      {
        path: 'add-line-product',
        loadComponent: () => import('./Pages/Shared/add-line-product/add-line-product.page'   ).then((m) => m.AddLineProductPage),
      },
      {
        path: 'add-signature',
        loadComponent: () => import('./Pages/Delivery-notes/add-signature/add-signature.page'   ).then((m) => m.AddSignaturePage),
      },
      {
        path: 'edit-line-product',
        loadComponent: () => import('./Pages/Delivery-notes/edit-line-product/edit-line-product.page'   ).then((m) => m.EditLineProductPage),
      },
      {
        path: 'product-order-filters',
        loadComponent: () => import('./Pages/Orders/product-order-filters/product-order-filters.page'   ).then((m) => m.ProductOrderFiltersPage),
      },
      {
        path: 'select-products',
        loadComponent: () => import('./Pages/Delivery-notes/select-products/select-products.page'   ).then((m) => m.SelectProductsPage),
      },
      {
        path: 'gallery',
        loadComponent: () => import('./Pages/Shared/gallery/gallery.page').then((m) => m.GalleryPage),
      },
    ],
  },
  {
    path: 'login',
    loadComponent: () => import('./Pages/Auth/login/login.page').then((m) => m.LoginPage),
  },
  {
    path: 'forget-pass',
    loadComponent: () => import('./Pages/Auth/forget-pass/forget-pass.page').then((m) => m.ForgetPassPage),
  },
  {
    path: 'register',
    loadComponent: () => import('./Pages/Auth/register/register.page').then((m) => m.RegisterPage),
  },
  {
    path: 'visor',
    loadComponent: () => import('./Pages/Auth/visor/visor.page').then((m) => m.VisorPage),
  },
];
